import React, { useCallback, useEffect, useState, FC } from 'react';
import './BannerModal.scss';

interface Iprops {
  items: number;
  currentItem: number;
}

const ScrollBar: FC<Iprops> = props => {
  const { items, currentItem } = props;
  if (items <= 1 || !items) {
    return null;
  }
  const offset = 64 / items;
  const height = `${offset}px`;
  const top = `${12 + offset * currentItem}px`;
  return (
    <>
      <div className="scrollBar" />
      <div className="filledBar" style={{ height, top }} />
    </>
  );
};

export default ScrollBar;
